//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "app",
  components: {},
  data() {
    return {
      cl: true,
      ieShow: false
    };
  },
  watch: {
    //观察Vue实例上的数据变动
  },
  computed: {
    //DOM加载后马上执行能够缓存数据
  },
  methods: {
    //触发事件
    submitUser(data, resData) {
      this.request(
        "/user/save",
        data,
        "POST",
        "application/x-www-form-urlencoded"
      )
        .then(res => {
          console.log(res);
          if (res.data.ret == 200) {
            console.log("保存用户成功");
          } else {
            this.$vux.toast.show({
              text: "网络出错,请重新登录",
              time: "2000",
              width: "5rem",
              position: "middle",
              type: "text"
            });
          }
        })
        .catch(err => {
          console.log(err);
          this.$vux.toast.show({
            text: "网络出错,请重新登录~",
            time: "2000",
            width: "5rem",
            position: "middle",
            type: "text"
          });
        });
    }
  },
  created() {
    //页面渲染前调用
    console.log("app渲染前");
    document.body.addEventListener(
      "touchmove",
      function(evt) {
        if (!evt._isScroller) {
          evt.preventDefault();
        }
      },
      {
        passive: false
      }
    ); //禁止屏幕滑动

    var appid = this.Global.appid;
    var wechat = new Wechat(appid);
    wechat.config({
      debug: false,
      jsApiList: [
        "checkJsApi",
        "onMenuShareTimeline",
        "onMenuShareAppMessage",
        "onMenuShareQQ",
        "onMenuShareWeibo"
      ]
    }); //初始
    //微信授权;
    var loca = localStorage.getItem(this.Global.appid);
    // console.log(this.Global.appid);
    // console.log(loca);
    var res = {
      city: "深圳",
      country: "ä¸­å½",
      headimgurl:
        "http://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83eondrEhftfHSN3zRTumazfmXt3kHhBic9npRuicG0STBxNY2QgVY40Bym6NyGOL5SOicO6hqEvhP71Gg/132",
      language: "zh_CN",
      nickname: "小程",
      openid: "ojxZdv-812th7lwlDK0GzvjBaSUc",
      privilege: [],
      province: "广东",
      sex: 1,
      unionid: "oMXNp1RAz4X-xeN-rzLe4CDmAqMQ"
    };
    localStorage.setItem(this.Global.appid, JSON.stringify(res));

    if (loca == null || loca == "") {
      location.reload();
    }

    function isIE() {
      //ie?
      if (!!window.ActiveXObject || "ActiveXObject" in window) return true;
      else return false;
    }

    if (isIE()) {
      this.ieShow = true;
    }
    var userAgent =  navigator.userAgerAgent;
    if (userAgent.indexOf("Safari") > -1) {
      this.ieShow = true;
      return "Safari";
    }
    // if (loca == null || loca == "") {
    // if (wechat.getQuery("code")) {
    //   //授权模式
    //   wechat.ready(() => {
    //     //获取用户的信息
    //     wechat.getUserInfo((err, res) => {
    //       if (err) {
    //         wechat.goAuth(
    //           "snsapi_userinfo",
    //           "state",
    //           wechat.filter("code", "state")
    //         );
    //       } else {
    //         console.log("授权成功");
    //         console.log(res);
    //         let data = {
    //           openid: res.openid,
    //           nick_name: res.nickname,
    //           headimg_url: res.headimgurl
    //         };

    //         this.submitUser(data, res);
    //         localStorage.setItem(this.Global.appid, JSON.stringify(res));

    //         // console.log("缓存为空");
    //         if (loca == null || loca == "") {
    //           location.reload();
    //         }
    //         // this.Global.openid = res.openid;
    //       }
    //     });
    //   });
    // } else {
    //   //授权跳转
    //   wechat.goAuth("snsapi_userinfo", "state", wechat.filter("code", "state"));
    // }
    // }
  },
  mounted() {
    //页面渲染完成调用
    console.log("app渲染完成");
  }
};



// WEBPACK FOOTER //
// ./src/App.vue